export const ButtonStyles = {
  primary: {
    backgroundColor: '#1010EB',
    border: 'none',
  },
  secondary: {
    backgroundColor: '#FFFFFF',
    color: '#1010EB',
    border: '1px solid #1010EB',
  },
  secondaryWhiteBorder: {
    backgroundColor: '#FFFFFF',
    color: '#1010EB',
    border: '1px solid #EBEBEB',
  },
  surgery: {
    backgroundColor: '#E50B7E',
    color: '#FFFFFF',
    border: 'none',
  },
  scheduleSurgery: {
    backgroundColor: '#FFFFFF',
    color: '#E50B7E',
    border: '1px dashed #E5047E',
  },
  disabled: {
    backgroundColor: '#9A9A9A',
    color: '#FFFFFF',
    border: 'none',
  },
  disabledReceiveSets: {
    backgroundColor: 'transparent',
    color: '#9F9F9F',
    border: '1px solid #9F9F9F',
  },
  warning: {
    backgroundColor: '#fcaa00',
    color: '#140f4b',
    border: 'none',
  },
  cancel: {
    backgroundColor: '#FFFFFF',
    color: '#140f4b',
    border: '1px solid #140F4B',
  },
  clearNotes: {
    backgroundColor: '#FFFFFF',
    color: '#140F4B',
    border: '1px solid #140F4B',
  },
  surgeryNotesDisabled: {
    backgroundColor: '#9A9A9A',
    color: '#FFFFFF',
    border: '1px solid #9A9A9A',
  },
  discard: {
    backgroundColor: '#FFFFFF',
    color: '#ED002A',
    border: '1px solid #ED002A',
  },
  listViewApply: {
    backgroundColor: '#1021EB',
    color: '#FFFFFF',
    border: 'none',
  },
  clearNotesBg: {
    backgroundColor: '#F5F5F5',
    color: '#140F4B',
    border: '1px solid #140F4B',
  },
  popUpSecondary: {
    backgroundColor: '#FFFFFF',
    color: '#1010EB',
    border: '1px solid #1010EB',
  },
  disabledSaveBtn: {
    backgroundColor: '#9F9F9F',
    color: '#FFFFFF',
    border: '1px solid #9F9F9F',
  },
  signatureBtnEnabled: {
    backgroundColor: '#ffffff',
    color: '#1010EB',
    border: '1px solid #ffffff',
  },
  signatureBtnDisabled: {
     backgroundColor: '#E6E6E6',
    color: '#888888',
    border: '1px solid #BCBCBC',
  },
  reportPaymentDisabled: {
    backgroundColor: '#EEEEEE',
    color: '#848484',
  },                                        
  shipToAddressEnabled: {
    color: '#FFFFFF',
    backgroundColor: '#1010EB'
  },
  shipToAddressDisabled: {
    color: '#8D8D8D',
    backgroundColor: '#E8E8E8'
  },
  clearSelectedEnabled: {
    color: '#1010EB',
    border: '1px solid #EBEBEB',
    backgroundColor: '#F4F4F5'
  },
  clearSelectedDisabled: {
    color: '#B2B2B2',
    border: '1px solid #EBEBEB',
    backgroundColor: '#F4F4F5'
  },
  bannerDismiss: {
    color: '#1010EB',
    border: '1px solid #1010EB',
    backgroundColor: '#98fff7'
  },
  bannerproxyBGColor: {
    color: '#1010EB',
    border: '1px solid #1010EB',
    backgroundColor: '#00DCB9'
  },
  bannerproxyAdminImpersonateBGColor: {
    color: '#1010EB',
    border: '1px solid #1010EB',
    backgroundColor: '#12C8F7'
  },
  secondaryGreyBorder: {
    backgroundColor: '#FFFFFF',
    border: '1px solid #9A9A9A',
  },
  priceoverrideDisabled: {
    backgroundColor: '#EEEEEE',
    color: '#888888',
    border: '0.6px solid #A5A5A5',
  },
  reportPaymentDisabledZLB:{
    backgroundColor: '#9F9F9F',
    color: '#FFFFFF',
    border: '0.6000000238418579px solid #A5A5A5',
  }
};
